import React, { createContext, useContext, ReactNode } from "react";

export interface BranchStartDate {
  day: number;
  month: number;
  year: number;
}

interface AnalyticsContextType {
  branchStartDate: BranchStartDate | null;
  loading: boolean;
  error: string | null;
}

const AnalyticsContext = createContext<AnalyticsContextType | undefined>(undefined);

export interface AnalyticsProviderProps {
  children: ReactNode;
  branchStartDate: BranchStartDate | null;
  loading: boolean;
  error: string | null;
}

export const AnalyticsProvider: React.FC<AnalyticsProviderProps> = ({
  children,
  branchStartDate,
  loading,
  error,
}) => {
  return (
    <AnalyticsContext.Provider value={{ branchStartDate, loading, error }}>
      {children}
    </AnalyticsContext.Provider>
  );
};

export const useAnalyticsContext = () => {
  const context = useContext(AnalyticsContext);
  if (context === undefined) {
    throw new Error("useAnalyticsContext must be used within an AnalyticsProvider");
  }
  return context;
};

/**
 * Convert BranchStartDate to a Date object
 */
export const convertBranchStartDateToDate = (
  branchStartDate: BranchStartDate | null
): Date | null => {
  if (!branchStartDate) return null;
  return new Date(branchStartDate.year, branchStartDate.month - 1, branchStartDate.day);
};
